const analyticsTracker = (analytics, localAnalyticsId, event) => {
  if (analytics) {
    const {
      id,
      description,
      callback
    } = analytics;
    if (analytics.localAnalyticsId) {
      // eslint-disable-next-line no-param-reassign
      localAnalyticsId = analytics.localAnalyticsId;
    }
    if (id && typeof callback === 'function') {
      callback(typeof localAnalyticsId === 'string' && localAnalyticsId !== '' ? `${id}.${localAnalyticsId}` : id, description || '', event);
    }
  }
};
export { analyticsTracker };